import React, { useContext } from 'react';
import { Map as MapIcon } from 'pcln-icons';
import { Text, Flex, Button, Box } from 'pcln-design-system';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
export const OpenMapButton = ({
  isLoading
}) => {
  const {
    hotelOnMapList,
    locationPinList,
    setOpenedMap,
    shouldUseMapFeature
  } = useContext(ChatbotDataContext);
  const hasPinOnMap = (hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.length) > 0 || (locationPinList === null || locationPinList === void 0 ? void 0 : locationPinList.length) > 0;
  if (!shouldUseMapFeature || !hasPinOnMap || isLoading) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    mt: 3,
    mb: 4,
    style: {
      position: 'relative'
    }
  }, React.createElement(Button, {
    size: 'small',
    style: {
      position: 'absolute',
      bottom: '0',
      left: '50%',
      transform: 'translate(-50%, 15px)'
    },
    onClick: function () {
      setOpenedMap(true);
    },
    title: 'Open Map'
  }, React.createElement(Flex, null, React.createElement(MapIcon, {
    color: 'lightest',
    size: 16
  }), React.createElement(Text, {
    ml: 1
  }, "Map")))));
};